import * as React from "react";
import Box from "@mui/material/Box";
import {
  Button,
  Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Modal,
  Select,
  TablePaginationProps,
  TextField,
  Typography,
} from "@mui/material";
import AssetModal from "./AssetModal";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useQuery } from "react-query";
import { AssetApi, AssetDto } from "../../../services/netServices";
import { useEffect } from "react";
import DataGridCustom from "../../../common/components/DataGrid";
import { GridColDef, GridPagination } from "@mui/x-data-grid";
import MuiPagination from "@mui/material/Pagination";
import { useStores } from "../../../models/helpers/useStores";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import AssetDetailModal from "./AssetDetailModal";
import CropOriginalIcon from "@mui/icons-material/CropOriginal";
import ExportModal from "./ExportModal";
import CateModal from "./CateModal";
import AddIcon from "@mui/icons-material/Add";
import ImportModal from "./ImportModal";

export default function TabAssetManagement() {
  const { t } = useTranslation() as any;
  const [searchTerm, setSearchTerm] = React.useState("");
  const [searchCate, setSearchCate] = React.useState("");
  const {
    appStore: { userProfile, getACLGroup },
  } = useStores();

  const [assetModalProps, setAssetModalProps] = React.useState<{
    visible: boolean;
    data?: AssetDto;
    isEditing: boolean;
  }>({
    visible: false,
    data: undefined,
    isEditing: false,
  });
  const [openModalExport, setOpenModalExport] = React.useState<boolean>(false);
  const [openNewCate, setOpenNewCate] = React.useState<boolean>(false);
  const [assetDetailModal, setAssetDetailModal] = React.useState<{
    visible: boolean;
    id: number;
  }>({
    visible: false,
    id: undefined,
  });
  const [debouncedSearchTerm, setDebouncedSearchTerm] =
    React.useState(searchTerm);
  const [previewImage, setPreviewImage] = React.useState<string | null>(null);
  const [selectedTags, setSelectedTags] = React.useState<number[]>([]);
  const [selectedDepartments, setSelectedDepartments] = React.useState<
    number | null
  >(null);
  const [selectedCates, setSelectedCates] = React.useState<number[]>([]);
  const [sortModel, setSortModel] = React.useState<any[]>([]);
  const [openImportModal, setOpenImportModal] = React.useState(false);

  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);
  const handleOpen = () =>
    setAssetModalProps({ visible: true, data: undefined, isEditing: false });
  const handleClose = () =>
    setAssetModalProps({ visible: false, data: undefined, isEditing: false });
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  });
  const [paginationDepartmentModel, setPaginationDepartmentModel] =
    React.useState({
      page: 0,
      pageSize: 100,
    });
  const getChildrenIds = React.useCallback(
    (parent: any) => parent.Childs?.map((c: any) => c.Id) ?? [],
    []
  );

  const handleToggle = (id: number, parent?: any) => {
    setSelectedCates((prev) => {
      // Nếu là parent
      if (parent) {
        const childIds = getChildrenIds(parent);

        // Nếu có con -> toggle con
        if (childIds.length > 0) {
          const isSelected = childIds.every((cid) => prev.includes(cid));
          return isSelected
            ? prev.filter((x) => !childIds.includes(x)) // bỏ hết con
            : [...prev, ...childIds.filter((cid) => !prev.includes(cid))]; // thêm con
        }

        // Nếu không có con -> toggle cha
        return prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id];
      }

      // Nếu là child
      const newSelected = prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id];

      // Nếu tất cả con đều được chọn thì thêm cha
      const parentOfChild = dataCate?.find((p) =>
        getChildrenIds(p).includes(id)
      );
      if (parentOfChild) {
        const allChildren = getChildrenIds(parentOfChild);
        const allChildrenSelected = allChildren.every((cid) =>
          newSelected.includes(cid)
        );
        if (allChildrenSelected) {
          return [...newSelected, parentOfChild.Id];
        } else {
          return newSelected.filter((x) => x !== parentOfChild.Id);
        }
      }

      return newSelected;
    });
  };

  const { data, refetch, isFetching } = useQuery(
    ["/Asset"],
    async () => {
      const sortField = sortModel[0]?.field ?? "";
      const isDescending = sortModel[0]?.sort === "desc";
      const { data } = await new AssetApi().assetGet(
        paginationModel.page + 1,
        paginationModel.pageSize,
        debouncedSearchTerm,
        selectedTags,
        selectedCates,
        selectedDepartments,
        0,
        sortField,
        isDescending
      );
      return data;
    },
    { enabled: false }
  );
  const { data: dataTags, refetch: refetchTags } = useQuery(
    ["/Asset/Tags"],
    async () => {
      const dataLocalStorage = localStorage.getItem("USER");
      const parsedData = JSON.parse(dataLocalStorage ?? "");
      const token = parsedData?.User?.token;
      const { data } = await new AssetApi().assetTagsGet(token);
      return data.Data;
    },
    { enabled: false }
  );
  const { data: dataDepartment, refetch: refetchDepartment } = useQuery(
    ["/Asset/Assignees"],
    async () => {
      const { data } = await new AssetApi().assetAssigneesGet(
        paginationDepartmentModel.page + 1,
        paginationDepartmentModel.pageSize
      );
      return data.Data;
    },
    { enabled: false }
  );
  const { data: dataCate, refetch: refetchCate } = useQuery(
    ["/Asset/Category"],
    async () => {
      const dataLocalStorage = localStorage.getItem("USER");
      const parsedData = JSON.parse(dataLocalStorage ?? "");
      const token = parsedData?.User?.token;
      const { data } = await new AssetApi().assetCategoryGet(token);
      return data.Data;
    },
    { enabled: false }
  );
  useEffect(() => {
    refetch();
    refetchCate();
    refetchTags();
    refetchDepartment();
  }, [
    refetch,
    refetchTags,
    refetchCate,
    refetchDepartment,
    paginationModel,
    debouncedSearchTerm,
  ]);
  useEffect(() => {
    refetch();
  }, [
    refetch,
    selectedTags,
    selectedCates,
    selectedDepartments,
    sortModel,
    // selectedConditions
  ]);

  const transformedData = React.useMemo(() => {
    return (data?.Data ?? []).map((item: AssetDto, index: number) => ({
      ...item,
      stt: index + 1 + paginationModel.page * paginationModel.pageSize,
      _rowId: `${item.Id}-${index}`,
    }));
  }, [data, paginationModel]);

  const { aclAsset } = React.useMemo(() => {
    const aclGroup = getACLGroup()?.[userProfile?.PrimaryGroup?.GroupId ?? 0];
    return {
      aclAsset: aclGroup?.asset,
    };
  }, [userProfile]);

  const getDisplayValue = (value: any) => {
    return value === null || value === undefined || value === "" ? "-" : value;
  };
  const columns: Array<GridColDef<AssetDto>> = [
    ...(aclAsset?.Edit || aclAsset?.Delete
      ? [
          {
            field: "Action",
            headerName: "",
            width: 60,
            sortable: false,
            renderCell: (response) => {
              // eslint-disable-next-line react-hooks/rules-of-hooks
              const [anchorEl, setAnchorEl] = React.useState(null);
              const open = Boolean(anchorEl);

              const handleClick = (event: React.MouseEvent<HTMLElement>) => {
                setAnchorEl(event.currentTarget);
              };

              const handleClose = () => {
                setAnchorEl(null);
              };

              return (
                <>
                  <IconButton onClick={handleClick}>
                    <MoreVertIcon sx={{ width: 13, height: 13 }} />
                  </IconButton>
                  <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    {aclAsset?.Edit && (
                      <MenuItem
                        onClick={() => {
                          setAssetModalProps({
                            visible: true,
                            data: response.row,
                            isEditing: true,
                          });
                          handleClose();
                        }}
                      >
                        <ListItemIcon>
                          <EditIcon fontSize="small" />
                        </ListItemIcon>
                        <Typography variant="inherit">
                          {t("00_03_edit")}
                        </Typography>
                      </MenuItem>
                    )}
                  </Menu>
                </>
              );
            },
          },
        ]
      : []),
    { field: "stt", headerName: "STT", sortable: false, width: 50 },
    {
      field: "SerialNumber",
      headerName: t("34_00_serial_number"),
      flex: 1,
      sortable: true,
      renderCell: (params) => getDisplayValue(params.value),
    },
    {
      field: "Brand",
      headerName: t("34_00_brand"),
      flex: 1,
      sortable: true,
      renderCell: (params) => getDisplayValue(params.value),
    },
    {
      field: "Name",
      headerName: t("34_00_asset_name"),
      flex: 1,
      sortable: true,
      renderCell: (params) => getDisplayValue(params.value),
    },

    {
      field: "Description",
      headerName: t("00_06_description"),
      flex: 1,
      sortable: false,
      renderCell: (params) => getDisplayValue(params.value),
    },
    {
      field: "Area",
      headerName: t("34_00_area"),
      flex: 1,
      sortable: false,
      renderCell: (params) => getDisplayValue(params.value),
    },
    {
      field: "Image",
      headerName: t("34_00_image"),
      width: 100,
      sortable: false,
      renderCell: (params) => {
        const imageUrl = params.value;
        return imageUrl ? (
          <CropOriginalIcon
            sx={{ fontSize: "16px", cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              setPreviewImage(imageUrl);
            }}
          />
        ) : (
          "-"
        );
      },
    },

    {
      field: "Unit",
      headerName: t("00_06_unit"),
      sortable: false,
      width: 100,
      renderCell: (params) => getDisplayValue(params.value),
    },
    {
      field: "Quantity",
      headerName: t("00_06_quantity"),
      sortable: false,
      width: 100,
      renderCell: (params) => getDisplayValue(params.value),
    },
  ];

  function Pagination({
    page,
    onPageChange,
    className,
  }: Pick<TablePaginationProps, "page" | "onPageChange" | "className">) {
    const pageCount = Math.ceil((data?.Totals ?? 0) / paginationModel.pageSize);
    return (
      <MuiPagination
        color="primary"
        className={className}
        count={pageCount}
        page={page + 1}
        onChange={(event, newPage) => {
          onPageChange(event as any, newPage - 1);
        }}
        showFirstButton
        showLastButton
      />
    );
  }

  function CustomPagination(props: any): JSX.Element {
    return (
      <GridPagination
        sx={{
          "& .MuiTablePagination-selectLabel": {
            minWidth: "auto",
          },
        }}
        ActionsComponent={Pagination}
        {...props}
      />
    );
  }

  const dataWithUncategory = [
    { Id: 0, Name: t("24_01_uncategorized"), Childs: [] },
    ...(dataCate ?? []),
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          height: "48px",
          display: "flex",
          alignItems: "center",
          mx: 4,
        }}
      >
        <Typography variant="h6">{t("00_01_asset")}</Typography>
      </Box>
      <Box sx={{ padding: 4 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: 4,
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchOutlinedIcon />
                  </InputAdornment>
                ),
              }}
              variant="outlined"
              placeholder={t("00_06_search")}
              size="small"
              value={searchTerm}
              onChange={(event) => {
                setSearchTerm(event.target.value);
              }}
              autoComplete="off"
            />
            <FormControl size="small" sx={{ width: 150 }}>
              <InputLabel>{t("34_00_tag")}</InputLabel>
              <Select
                multiple
                label={t("34_00_tag")}
                value={selectedTags} // selectedTags là number[] (list Id)
                sx={{ minHeight: "40px" }}
                onChange={(e) => {
                  const value = e.target.value as number[];
                  setSelectedTags(value);
                }}
                renderValue={(selected) => {
                  // selected là mảng Id => map ra Name
                  const names = (selected as number[])
                    .map((id) => dataTags?.find((tag) => tag.Id === id)?.Name)
                    .filter(Boolean); // loại null/undefined
                  return names.join(", ");
                }}
              >
                {dataTags?.length > 0 ? (
                  dataTags?.map((tag) => (
                    <MenuItem key={tag.Id} value={tag.Id}>
                      <Checkbox checked={selectedTags.indexOf(tag.Id) > -1} />
                      <ListItemText primary={tag.Name ?? `Tag ${tag.Id}`} />
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>
                    <ListItemText primary={t("00_06_no_data")} />
                  </MenuItem>
                )}
              </Select>
            </FormControl>

            <FormControl size="small" sx={{ width: 250 }}>
              <InputLabel>{t("13_05_category")}</InputLabel>
              <Select
                multiple
                label={t("13_05_category")}
                value={selectedCates}
                sx={{ minHeight: "40px" }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 400,
                    },
                  },
                }}
                renderValue={(selected) => {
                  const names = (selected as number[])
                    .map((id) => {
                      const parent = dataCate?.find((p) => p.Id === id);
                      if (parent) return parent.Name;
                      const child = dataCate
                        ?.flatMap((p) => p.Childs ?? [])
                        .find((c) => c.Id === id);
                      return child?.Name;
                    })
                    .filter(Boolean);
                  return names.join(", ");
                }}
              >
                {/* Search input */}
                <MenuItem disableRipple disableTouchRipple>
                  <TextField
                    size="small"
                    placeholder={t("00_06_search")}
                    fullWidth
                    value={searchCate}
                    onChange={(e) => setSearchCate(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    autoFocus
                    onKeyDown={(e) => e.stopPropagation()}
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                  />
                </MenuItem>

                {/* Thêm mới */}
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenNewCate(true);
                  }}
                >
                  <AddIcon
                    fontSize="small"
                    sx={{ mr: 1, ml: 2, color: "rgba(0, 0, 0, 0.54)" }}
                  />
                  <ListItemText
                    sx={{ color: "rgb(99, 99, 99)" }}
                    primary={t("34_00_new_category")}
                  />
                </MenuItem>

                {/* Parent + children */}
                {dataWithUncategory
                  ?.filter((parent) =>
                    !searchCate
                      ? true
                      : parent.Name.toLowerCase().includes(
                          searchCate.toLowerCase()
                        ) ||
                        parent.Childs?.some((c: any) =>
                          c.Name.toLowerCase().includes(
                            searchCate.toLowerCase()
                          )
                        )
                  )
                  .flatMap((parent) => {
                    const children = parent.Childs ?? [];
                    const childrenSelected = children.filter((c: any) =>
                      selectedCates.includes(c.Id)
                    );

                    const parentChecked =
                      children.length > 0
                        ? childrenSelected.length === children.length
                        : selectedCates.includes(parent.Id);

                    const parentIndeterminate =
                      children.length > 0 &&
                      childrenSelected.length > 0 &&
                      childrenSelected.length < children.length;

                    return [
                      //  Parent item
                      <MenuItem
                        key={`parent-${parent.Id}`}
                        onClick={() => handleToggle(parent.Id, parent)}
                      >
                        <Checkbox
                          checked={parentChecked}
                          indeterminate={parentIndeterminate}
                        />
                        <ListItemText primary={parent.Name} />
                      </MenuItem>,

                      //  Children item
                      ...(parent.Childs?.filter((c: any) =>
                        !searchCate
                          ? true
                          : c.Name.toLowerCase().includes(
                              searchCate.toLowerCase()
                            )
                      ).map((child: any) => (
                        <MenuItem
                          key={`child-${child.Id}`}
                          onClick={() => handleToggle(child.Id)}
                          sx={{ pl: 8 }}
                        >
                          <Checkbox
                            checked={selectedCates.includes(child.Id)}
                            size="small"
                          />
                          <ListItemText primary={child.Name} />
                        </MenuItem>
                      )) ?? []),
                    ];
                  })}

                {/* No data */}
                {dataWithUncategory &&
                  dataWithUncategory.filter((parent) =>
                    !searchCate
                      ? true
                      : parent.Name.toLowerCase().includes(
                          searchCate.toLowerCase()
                        ) ||
                        parent.Childs?.some((c: any) =>
                          c.Name.toLowerCase().includes(
                            searchCate.toLowerCase()
                          )
                        )
                  ).length === 0 && (
                    <MenuItem disabled>
                      <ListItemText primary={t("00_06_no_data")} />
                    </MenuItem>
                  )}
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ width: 200 }}>
              <InputLabel>{t("34_00_department")}</InputLabel>
              <Select
                label={t("34_00_department")}
                value={selectedDepartments ?? ""}
                sx={{ minHeight: "40px" }}
                renderValue={(selected) => {
                  const dep = dataDepartment?.find(
                    (d) => d.DepartmentId === selected
                  );
                  return dep ? dep.DepartmentName : "";
                }}
              >
                {dataDepartment?.length > 0 ? (
                  dataDepartment.map((dep) => (
                    <MenuItem
                      key={dep.DepartmentId}
                      value={dep.DepartmentId}
                      onClick={() => {
                        if (selectedDepartments === dep.DepartmentId) {
                          setSelectedDepartments(null); // uncheck
                        } else {
                          setSelectedDepartments(dep.DepartmentId); // chọn mới
                        }
                      }}
                    >
                      <Checkbox
                        checked={selectedDepartments === dep.DepartmentId}
                      />
                      <ListItemText primary={dep.DepartmentName} />
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>
                    <ListItemText primary={t("00_06_no_data")} />
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ display: "flex", gap: 4 }}>
            <Box>
              <Button
                variant="outlined"
                onClick={() => {
                  setOpenModalExport(true);
                }}
                sx={{
                  textTransform: "none",
                  fontSize: "13px",
                  fontWeight: 400,
                  color: "rgb(99, 99, 99)",
                }}
              >
                {t("34_00_export")}
              </Button>
            </Box>
            <Button
              variant="outlined"
              sx={{
                textTransform: "none",
                fontSize: "13px",
                fontWeight: 400,
                color: "rgb(99, 99, 99)",
              }}
              onClick={() => setOpenImportModal(true)}
            >
              {t("00_03_import")}
            </Button>
            {/* Nút Tạo mới */}
            {aclAsset?.Create && (
              <Button
                variant="contained"
                style={{ color: "#fff", backgroundColor: "#08B0A0" }}
                onClick={handleOpen}
              >
                {t("34_00_new_asset")}
              </Button>
            )}
          </Box>
        </Box>

        <Box>
          <DataGridCustom
            loading={isFetching}
            paginationModel={paginationModel}
            rows={transformedData ?? []}
            rowCount={data?.Totals ?? 0}
            columns={columns}
            paginationMode="server"
            sortingMode="server"
            onPaginationModelChange={setPaginationModel}
            getRowId={(row) => row._rowId}
            slots={{
              pagination:
                (data?.Totals ?? 0) > 0 ? CustomPagination : () => null,
            }}
            onSortModelChange={setSortModel}
            sortModel={sortModel}
            sortingOrder={["asc", "desc"]}
            localeText={{
              noRowsLabel: t("00_06_no_data"),
            }}
            slotProps={{
              pagination: {
                labelRowsPerPage: "",
              },
            }}
            onCellClick={(params, event) => {
              if (params.field === "Action") return;
              setAssetDetailModal({
                visible: true,
                id: params.row.Id ?? 0,
              });
            }}
            sx={{
              "& .MuiDataGrid-row": {
                cursor: "pointer",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#f5f5f5",
              },
              "& .MuiDataGrid-cell:focus": {
                outline: "none",
              },
              "& .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-cell": {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              "& .MuiDataGrid-cell:hover": {
                overflow: "hidden",
              },
            }}
          />
        </Box>
      </Box>
      {assetModalProps.visible && (
        <AssetModal
          open={assetModalProps.visible}
          asset={assetModalProps?.data}
          onClose={handleClose}
          refetchGetListAsset={refetch}
          isEditing={assetModalProps.isEditing}
        />
      )}
      {openModalExport && (
        <ExportModal
          open={openModalExport}
          onClose={() => {
            setOpenModalExport(false);
          }}
          sortModel={sortModel}
          paginationModel={paginationModel}
          debouncedSearchTerm={debouncedSearchTerm}
          selectedTags={selectedTags}
          selectedCates={selectedCates}
          selectedDepartments={selectedDepartments}
        />
      )}
      {openNewCate && (
        <CateModal
          open={openNewCate}
          onClose={() => {
            setOpenNewCate(false);
          }}
          onSuccess={() => {
            refetchCate();
          }}
        />
      )}
      {openImportModal && (
        <ImportModal
          open={openImportModal}
          onClose={() => setOpenImportModal(false)}
          onSuccess={() => {
            refetch();
            setOpenImportModal(false);
          }}
        />
      )}
      {assetDetailModal.visible && (
        <AssetDetailModal
          open={assetDetailModal.visible}
          onClose={() => setAssetDetailModal({ visible: false, id: undefined })}
          id={assetDetailModal.id}
        />
      )}
      <Modal
        open={Boolean(previewImage)}
        onClose={() => setPreviewImage(null)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(2px)",
        }}
      >
        <Box sx={{ outline: "none" }}>
          <img
            src={previewImage ?? ""}
            alt="preview"
            style={{
              maxHeight: "auto",
              maxWidth: "500px",
              objectFit: "contain",
              borderRadius: 8,
            }}
          />
        </Box>
      </Modal>
      <ToastContainer
        position="bottom-left"
        autoClose={3000}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        toastClassName="custom-toast"
        hideProgressBar={true}
        icon={false}
      />
    </Box>
  );
}
